import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function DraftResume() {
  const { draftToken } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    api
      .get(`/projects/draft/${draftToken}`)
      .then((r) => {
        const p = r.data;
        localStorage.setItem("rcw_draft_token", draftToken);
        if (p.submission_type === "photo_first") navigate(`/submit-photos/${draftToken}`);
        else navigate(`/submit/${draftToken}`);
      })
      .catch(() => navigate("/"));
  }, [draftToken]);
  return (
    <div className="min-h-screen flex items-center justify-center text-gray-500">
      <Loader2 className="h-5 w-5 animate-spin mr-2" /> Resuming your draft…
    </div>
  );
}
